function getURLVar(key) {
var value = [];
var query = String(document.location).split('?');
if (query[1]) {
var part = query[1].split('&');
for (var i = 0; i < part.length; i++) {
var data = part[i].split('=');
if (data[0] && data[1]) {
value[data[0]] = data[1];
}
}
if (value[key]) {
return value[key];
} else {
return '';
}
}
return '';
}

function isEmpty(el){
return !$.trim(el.html());
}

$(document).ajaxStop(function() {
if (!isEmpty($('#product'))) {
$('#product .option-container').addClass('has-option');
}
});

// resize code for equal size grids and content start
var img_ratio = 2.0/3.0;


$(document).ready(function() {

$('.shopify-currency-form select').on('change', function() {
$(this).parents('form').submit();
});



// sidebar mobile toggle code start
if ($(window).width() <=991 ) {

$('#sidebar-toggle .oc-menu-bar').click(function (e) {
e.stopPropagation();
var effect = $(this).closest('#sidebar-toggle.oc-menu').find('.menu-effect').val();
$('#column-left').addClass('sidebar-toggle');
$('.sidebar-overlay').toggle();

if(effect == "none")  { $('#column-left').toggle(); }
if(effect == "fade")  { $('#column-left').fadeToggle(); }
if(effect == "slide") { $('#column-left').slideToggle(); }
});

$('#column-left').click(function(e){
e.stopPropagation();
});

$(document.body).click(function(e){
var effect = $('#sidebar-toggle.oc-menu').find('.menu-effect').val();
$('.sidebar-overlay').hide();
if(effect == "none")  { $('#column-left').hide(); }
if(effect == "fade")  { $('#column-left').fadeOut(); }
if(effect == "slide") { $('#column-left').slideUp(); }
});
}
// sidebar mobile toggle code end

// Adding active class for mobtabs on mobile layout
$('.mobtab a').click(function(e){
$('.mobtab a').removeClass('active');
$(this).addClass('active');
});

// product video
$('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
type: 'iframe',
mainClass: 'mfp-fade',
removalDelay: 160,
preloader: false,
fixedContentPos: false
});

// color swatch js snippet
$('.swatch :radio').change(function() {
var optionIndex = $(this).closest('.swatch').attr('data-option-index');
var optionValue = $(this).val();
$(this).closest('form')
.find('.single-option-selector')
.eq(optionIndex)
.val(optionValue)
.trigger('change');
});

/* =========================================================
AFB — ADD TO CART HUD (substitui toastr no add-to-cart)
========================================================= */
window.AFB_AddToCartToast = (function(){
var root, timer, lastTs = 0;

function ensure(){
if (root) return root;

root = document.createElement('div');
root.id = 'afbAddToast';
root.className = 'is-hidden';

root.innerHTML =
"<div class='afb-addtoast__inner'>" +
"<div class='afb-addtoast__row'>" +
"<div class='afb-addtoast__icon' aria-hidden='true'>✓</div>" +
"<div>" +
"<div class='afb-addtoast__title'>Item adicionado ao carrinho!</div>" +
"<div class='afb-addtoast__sub'>Pronto pra finalizar? 😄</div>" +
"</div>" +
"<div class='afb-addtoast__spacer'></div>" +
"<button type='button' class='afb-addtoast__close' aria-label='Fechar'>×</button>" +
"</div>" +

"<div class='afb-addtoast__actions'>" +
"<a class='afb-addtoast__btn' href='/cart'>Ver carrinho</a>" +
"<a class='afb-addtoast__btn is-primary' href='/checkout'>Finalizar compra</a>" +
"</div>" +

"<div class='afb-addtoast__bar' aria-hidden='true'><i></i></div>" +
"</div>";

document.body.appendChild(root);

root.querySelector('.afb-addtoast__close').addEventListener('click', hide);

// pausa timer no hover (evita “piscar”)
root.addEventListener('mouseenter', function(){
if (timer) { clearTimeout(timer); timer = null; }
});
root.addEventListener('mouseleave', function(){
timer = setTimeout(hide, 2200);
});

return root;
}

function pulseCart(){
var el =
document.querySelector('#cart > button') ||
document.querySelector('#cart button') ||
document.querySelector('#cart') ||
null;

if (!el) return;

if (!el.id) el.id = 'afbCartPulseTarget';
el.classList.remove('afb-cart-bump');
void el.offsetWidth;
el.classList.add('afb-cart-bump');
setTimeout(function(){ el.classList.remove('afb-cart-bump'); }, 520);
}

function show(opts){
// 🚫 se houver bloqueio Funko ativo (toast Funko), não mostra toast padrão
var funkoBox = document.getElementById('afbFunkoMinBox');
if (funkoBox && funkoBox.dataset && funkoBox.dataset.kind === 'funko') return;

opts = opts || {};
lastTs = Date.now();

var el = ensure();
el.classList.remove('is-hidden');
el.classList.add('is-show');

var title = el.querySelector('.afb-addtoast__title');
var sub   = el.querySelector('.afb-addtoast__sub');

if (title) title.textContent = opts.title || "Item adicionado ao carrinho!";
if (sub)   sub.textContent   = opts.sub   || "Pronto pra finalizar? 😄";

var dur = opts.dur || 4200;
el.style.setProperty('--dur', dur + 'ms');

var bar = el.querySelector('.afb-addtoast__bar i');
if (bar) {
bar.style.animation = 'none';
void bar.offsetWidth;
bar.style.animation = '';
}

pulseCart();

if (timer) clearTimeout(timer);
timer = setTimeout(hide, dur);
}

function hide(){
if (!root) return;
root.classList.remove('is-show');
setTimeout(function(){
if (!root) return;
root.classList.add('is-hidden');
}, 220);
}

return { show: show, hide: hide };
})();


// =====================================
// AFB — DETECTA FUNKO NA PÁGINA DO PRODUTO (PDP)
// =====================================
function AFB_isFunkoPDP(){
// marcador opcional seu
if (document.querySelector(".funko-cta")) return true;

// vendor link padrão do tema
var vendorLink = document.querySelector('.manufacture-product a[href*="/collections/vendors"]');
if (vendorLink && /funko/i.test(vendorLink.textContent || "")) return true;

// fallback: alguns temas imprimem vendor em texto
var vendorBox =
document.querySelector('.manufacture-product') ||
document.querySelector('[itemprop="brand"]') ||
document.querySelector('.product-vendor, .product__vendor');
if (vendorBox && /funko/i.test(vendorBox.textContent || "")) return true;

return false;
}

function AFB_getPDPQty(){
var el =
document.querySelector('#form_buy input[name="quantity"]') ||
document.querySelector('#form_buy_sticky input[name="quantity"]') ||
document.querySelector('form[action^="/cart/add"] input[name="quantity"]') ||
document.querySelector('input[name="quantity"]') ||
document.getElementById('input-quantity') ||
document.getElementById('Quantity');

var n = el ? parseInt(el.value, 10) : 1;
return (isFinite(n) && n > 0) ? n : 1;
}

function AFB_funkoMinQty(){
return 5; // seu mínimo
}

// Mensagem inline pro "Compre Já" em Funko (qty < 5) — sem optional chaining
function AFB_showFunkoBuyNowInline(){
var min = AFB_funkoMinQty();
var q = AFB_getPDPQty();
var missing = Math.max(0, min - q);

var btn = document.querySelector('#button-cart-buy');
var wrap = (btn && btn.parentNode) ? btn.parentNode : (document.querySelector('#form_buy') || document.body);

var box = wrap.querySelector(".afbFunkoInlineMsg");
if (!box) {
box = document.createElement("div");
box.className = "afbFunkoInlineMsg";
wrap.appendChild(box);
}

box.innerHTML =
"<div class='afb-funko-msg'>" +
"<div class='afb-funko-ic' aria-hidden='true'>!</div>" +
"<div class='afb-funko-body'>" +
"<div class='afb-funko-toprow'>" +
"<div class='afb-funko-title'>Ops! Vendemos o mínimo de 5 peças 👀</div>" +
"</div>" +
"<div class='afb-funko-main'>" +
"Para usar <strong>Compre Já</strong>, selecione <strong>" + min + "</strong> unidades " +
"<span class='afb-funko-sub'>(do mesmo modelo)</span>." +
"<div class='afb-funko-counter'>" +
"<span class='afb-funko-missing'>Faltam <strong>" + missing + "</strong> unidade(s).</span>" +
"</div>" +
"</div>" +
"</div>" +
"</div>";
}

function AFB_clearFunkoBuyNowInline(){
var btn = document.querySelector('#button-cart-buy');
var wrap = (btn && btn.parentNode) ? btn.parentNode : (document.querySelector('#form_buy') || null);
var box = wrap ? wrap.querySelector(".afbFunkoInlineMsg") : null;
if (box) box.remove();
}


// product page add to cart
$('#button-cart').on('click', function(e) {
e.preventDefault();
$.ajax({
url: '/cart/add.js',
type: 'post',
data: $('#form_buy input[type=\'text\'], #form_buy select'),
dataType: 'json',
beforeSend: function() {
$('#button-cart').button('loading');
},
complete: function() {
$('#button-cart').button('reset');
},
success: function(json) {
var i;

$('.alert, .text-danger').remove();
$('.form-group').removeClass('has-error');

if (json['error']) {
if (json['error']['option']) {
for (i in json['error']['option']) {
var element = $('#input-option' + i.replace('_', '-'));
if (element.parent().hasClass('input-group')) {
element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
} else {
element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
}
}
}
if (json['error']['recurring']) {
$('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
}
$('.text-danger').parent().addClass('has-error');
}

// ✅ substitui toastr
AFB_AddToCartToast.show({
title: "Parabéns! Seu item foi adicionado.",
sub: "Clique em Finalizar compra quando quiser ✨",
dur: 4200
});

$.getJSON('/cart.js', function(cart) {
load(cart);
});

$('html, body').animate({ scrollTop: 0 }, 'slow');
},
error: function(xhr, ajaxOptions, thrownError) {
if(xhr.status == 422 ) {
toastr.warning("Variante do item já adicionada ao carrinho.");
} else {
alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
}
}
});
});

$('#button-cart-sticky').on('click', function(e) {
e.preventDefault();
$.ajax({
url: '/cart/add.js',
type: 'post',
data: $('#form_buy input[type=\'text\'], #form_buy_sticky select'),
dataType: 'json',
beforeSend: function() {
$('#button-cart-sticky').button('loading');
},
complete: function() {
$('#button-cart-sticky').button('reset');
},
success: function(json) {
var i;

$('.alert, .text-danger').remove();
$('.form-group').removeClass('has-error');

if (json['error']) {
if (json['error']['option']) {
for (i in json['error']['option']) {
var element = $('#input-option' + i.replace('_', '-'));
if (element.parent().hasClass('input-group')) {
element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
} else {
element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
}
}
}
if (json['error']['recurring']) {
$('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
}
$('.text-danger').parent().addClass('has-error');
}

// ✅ substitui toastr
AFB_AddToCartToast.show({
title: "Parabéns! Seu item foi adicionado.",
sub: "Seu carrinho já está pronto ✅",
dur: 4200
});

$.getJSON('/cart.js', function(cart) {
load(cart);
});

$('html, body').animate({ scrollTop: 0 }, 'slow');
},
error: function(xhr, ajaxOptions, thrownError) {
if(xhr.status == 422 ) {
toastr.warning("Variante do item já adicionada ao carrinho.");
} else {
alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
}
}
});
});

// ✅ BUY NOW com bloqueio Funko < 5 + marca sessão "voltando do checkout"
$('#button-cart-buy').on('click', function(e) {
e.preventDefault();

try{
if (AFB_isFunkoPDP()) {
var min = AFB_funkoMinQty();
var q = AFB_getPDPQty();
if (q < min) {
AFB_showFunkoBuyNowInline();
return;
} else {
AFB_clearFunkoBuyNowInline();
}
}
}catch(err){}

$.ajax({
url: '/cart/add.js',
type: 'post',
data: $('#form_buy input[type=\'text\'], #form_buy select'),
dataType: 'json',
beforeSend: function() {
$('#button-cart-buy').button('loading');
},
complete: function() {
$('#button-cart-buy').button('reset');
},
success: function(json) {
var i;

$('.alert, .text-danger').remove();
$('.form-group').removeClass('has-error');

if (json['error']) {
if (json['error']['option']) {
for (i in json['error']['option']) {
var element = $('#input-option' + i.replace('_', '-'));
if (element.parent().hasClass('input-group')) {
element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
} else {
element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
}
}
}
if (json['error']['recurring']) {
$('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
}
$('.text-danger').parent().addClass('has-error');
}

// (buy now) vai pro checkout
$.getJSON('/cart.js', function(cart) {
try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
window.top.location.href="/checkout";
});
},
error: function(xhr, ajaxOptions, thrownError) {
if(xhr.status == 422 ) {
toastr.warning("Variante do item já adicionada ao carrinho.");
} else {
alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
}
}
});
});

//stickyMenu();
var sticky_menu = $('#sticky-menu').attr('data-sticky');
if (sticky_menu==1){
var headerSpaceH = 0;
if ($(".common-home").length == 0){
if ($(".hd3").length == 0) {
headerSpaceH = $('header .header-inner').outerHeight(true);
}
} else {
headerSpaceH = $('header').outerHeight(true) + $('header').offset().top;
}
$('header').before('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');
}

// Scroll
var currentP = 0;
var stickyOffset1 = 0;
var stickyOffset = 0;
stickyOffset = $('header').offset().top;
stickyOffset += $('header').outerHeight();
stickyOffset += 30;

if (!isEmpty($('#product-product'))) {
stickyOffset1 = $('#form_buy').offset().top;
stickyOffset1 += $('#form_buy').outerHeight();
}

$(window).scroll(function(){
var headerH = $('header').height();
var scrollP = $(window).scrollTop();
var winInnW = window.innerWidth;

if(scrollP != currentP){
//Sticky header
if( winInnW > 991 ){
if (sticky_menu==1){
if(scrollP >= stickyOffset){
$('.fix').addClass('fix-header');
$('.headerSpace').removeClass('unvisible');
if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
if (($(".bottom-menu").length == 0)) {
$('.headerSpace').addClass('show');
}
}
} else {
$('.fix').removeClass('fix-header');
$('.headerSpace').addClass('unvisible');
if (($(".hd3").length == 0 ) || ($(".hd4").length == 0)) {
if (($(".bottom-menu").length == 0)) {
$('.headerSpace').removeClass('show');
}
}
}
}
}

if (!isEmpty($('#product-product'))) {
if(scrollP >= stickyOffset1){
$('.form_buy_sticky').addClass('fix-header2');
$('.form_buy_sticky').addClass('fix-header1');
$('html').css('padding-bottom','64px');
} else {
$('.form_buy_sticky').removeClass('fix-header1');
$('.form_buy_sticky').removeClass('fix-header2');
$('html').css('padding-bottom','0px');
}
}
currentP = $(window).scrollTop();
}
});

if (!isEmpty($('#product')))  { $('#product .option-container').addClass('has-option'); }
if (!isEmpty($('#product2'))) { $('#product2 .option-container').addClass('has-option'); }

// move breadcrumbs
var breadcrumb = $('ul.breadcrumb');
var breadcrumbs_container = $('.breadcrumbs .container');
breadcrumb.appendTo(breadcrumbs_container);

// Highlight any found errors
$('.text-danger').each(function() {
var element = $(this).parent().parent();
if (element.hasClass('form-group')) {
element.addClass('has-error');
}
});

/* Search */
$('#search input[name=\'q\']').parent().find('button').on('click', function() {
var url = '/search';
var value = $('#search input[name=\'q\']').val();
if(value == "Search all products..." || value ==""){
$('#search .search-content input[name=\'q\']').focus();
return false;
} else {
url += '?type=product&q=' + encodeURIComponent(value);
}
location = url;
});

$('#search input[name=\'q\']').on('keydown', function(e) {
if (e.keyCode == 13) {
$('header #search input[name=\'q\']').parent().find('button').trigger('click');
}
});

// Menu
$('#menu .dropdown-menu').each(function() {
var menu = $('#menu').offset();
var dropdown = $(this).parent().offset();
var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());
if (i > 0) {
$(this).css('margin-left', '-' + (i + 10) + 'px');
}
});

if (localStorage.getItem('display') == null) {
$('#list-view').trigger('click');
} else if (localStorage.getItem('display') == 'grid') {
$('#grid-view').trigger('click');
} else {
$('#list-view').trigger('click');
}

// Checkout
$(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
if (e.keyCode == 13) {
$('#collapse-checkout-option #button-login').trigger('click');
}
});

// tooltips on hover
$('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

// Makes tooltips work on ajax generated content
$(document).ajaxStop(function() {
$('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
});

}); // end ready


// =========================================================
// Cart add/remove (FIX DEFINITIVO)
// - add: /cart/add.js
// - remove: /cart/change.js usando item.key (line item key)
// =========================================================
var cart = {
'add': function(product_id, quantity, redirect) {
$.ajax({
url: '/cart/add.js',
type: 'post',
data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
dataType: 'json',
beforeSend: function() {
if (redirect) {
$('.button-cart.button').button('loading');
} else {
$('.button-cart > .button').button('loading');
}
},
complete: function() {
if (redirect) {
$('.button-cart.button').button('reset');
} else {
$('.button-cart > .button').button('reset');
}
},
success: function(json) {
$('.alert, .text-danger').remove();

if (json['redirect']) location = json['redirect'];

if (window.AFB_AddToCartToast) {
AFB_AddToCartToast.show({
title: "Parabéns! Seu item foi adicionado.",
sub: (redirect ? "Indo pro checkout... 🚀" : "Quer finalizar agora? ✅"),
dur: (redirect ? 2200 : 4200)
});
} else if (window.toastr) {
toastr.success("Parabéns! Seu item foi adicionado.");
}

$.getJSON('/cart.js', function(c) {
if (redirect) {
try{ sessionStorage.setItem("AFB_FROM_CHECKOUT", "1"); }catch(e){}
window.top.location.href = "/checkout";
} else {
load(c);
}
});
},
error: function(xhr, ajaxOptions, thrownError) {
if (xhr.status == 422) {
toastr.warning("Variante do item já adicionada ao carrinho.");
} else {
alert(thrownError + "\r\n" + xhr.statusText + "\r\n" + xhr.responseText);
}
}
});
},

'remove': function(lineItemKey) {
$.ajax({
url: '/cart/change.js',
type: 'post',
data: 'id=' + encodeURIComponent(lineItemKey) + '&quantity=0',
dataType: 'json',
success: function(cartData) {

// se estiver na página /cart, recarrega pra manter tudo consistente
if (location.pathname === '/cart') {
location.reload();
return;
}

load(cartData);

// ✅ evita o “reset” ressuscitar número antigo
var $btn = $('#cart > button');
if ($btn.length) {
$btn.data('resetText', $btn.html());
$btn.button('reset');
}
},
error: function(xhr) {
alert(xhr.responseText);
}
});
}
};

/* =========================================================
AFB — FIX MINI-CART FANTASMA (bfcache) + remove compatível
- Re-sincroniza mini-cart ao voltar do checkout (sem reload)
- cart.remove aceita: key OU variantId OU line(1,2,3...)
========================================================= */
(function(){
if (window.__AFB_MINICART_FIX_READY) return;
window.__AFB_MINICART_FIX_READY = true;

var SS_FROM_CHECKOUT = "AFB_FROM_CHECKOUT";

function markFromCheckout(){
try{ sessionStorage.setItem(SS_FROM_CHECKOUT, "1"); }catch(e){}
}
function cameFromCheckout(){
try{ return sessionStorage.getItem(SS_FROM_CHECKOUT) === "1"; }catch(e){ return false; }
}
function clearFromCheckout(){
try{ sessionStorage.removeItem(SS_FROM_CHECKOUT); }catch(e){}
}

function isBackForwardNav(){
try{
if (performance && performance.getEntriesByType) {
var nav = performance.getEntriesByType('navigation')[0];
if (nav && nav.type) return nav.type === 'back_forward';
}
}catch(e){}
return false;
}

function isCheckoutPath(){
try{
var p = (location && location.pathname) ? String(location.pathname) : "";
return /\/checkouts?\b/i.test(p);
}catch(e){}
return false;
}

function syncMiniCart(){
if (isCheckoutPath()) return;
if (typeof jQuery === "undefined") return;

// se nem existe mini-cart no DOM, não faz nada
if (!document.querySelector('#cart .dropdown-menu')) return;

jQuery.getJSON("/cart.js", function(c){
if (typeof load === "function") {
load(c);
}
});
}

// marca quando o usuário vai pro checkout (serve pro pageshow)
document.addEventListener("click", function(ev){
var a = ev.target && ev.target.closest ? ev.target.closest('a[href*="/checkout"], a[href*="/checkouts/"]') : null;
if (a) markFromCheckout();
}, true);

// marca quando vai pro checkout via submit (caso exista)
document.addEventListener("submit", function(ev){
try{
var f = ev.target;
var act = (f && f.action) ? String(f.action) : "";
if (/\/checkouts?\b/i.test(act)) markFromCheckout();
}catch(e){}
}, true);

// ao voltar (bfcache/back-forward), re-sincroniza o mini-cart
window.addEventListener("pageshow", function(e){
var backLike = (e && e.persisted) || isBackForwardNav() || cameFromCheckout();
if (backLike){
clearFromCheckout();
syncMiniCart();
}
}, true);

// ao abrir o mini-cart, também garante que está atualizado (throttle)
if (window.jQuery) {
jQuery(function($){
var t = 0;
$(document).on("click mouseenter", "#cart, #cart > button, #cart button", function(){
var now = Date.now();
if (now - t < 600) return;
t = now;
syncMiniCart();
});
});
}

// --- BLINDAGEM: cart.remove aceita key / variantId / line ---
if (!window.cart || typeof window.cart.remove !== "function") return;

var _rm = window.cart.remove;

window.cart.remove = function(idOrKey){
var s = String(idOrKey || "").trim();
if (!s) return;

// key geralmente contém ":" (ex: 1234567890:abcd...)
if (s.indexOf(":") !== -1) {
return _rm(s);
}

if (typeof jQuery === "undefined") {
return _rm(s); // fallback
}

jQuery.getJSON("/cart.js", function(c){
var items = (c && c.items) ? c.items : [];

// 1) se veio "line" (1,2,3...), converte pra key real
if (/^\d{1,3}$/.test(s) && items.length) {
var idx = parseInt(s, 10) - 1;
if (idx >= 0 && idx < items.length && items[idx] && items[idx].key) {
return _rm(items[idx].key);
}
}

// 2) se veio variantId (HTML antigo), converte para key
var key = "";
for (var i=0;i<items.length;i++){
if (String(items[i].id) === s){
key = items[i].key;
break;
}
}

if (key) {
_rm(key); // ✅ remove correto
} else {
// ✅ era fantasma (não existe no cart real) => só re-render (se load já existe)
if (typeof load === "function") load(c);
}
});
};

})();


// =========================================================
// MINI CART RENDER (FIX ícone X + remove correto)
// =========================================================
function load(cartData){
$('#cart .dropdown-menu > li:first-child .table > tbody > tr').remove();

$.each(cartData.items, function (index, item) {

// ✅ remove por key (line item key)
var cartRemove = "onclick=\"cart.remove('" + item.key + "')\"";

// ✅ preço correto (centavos)
var unitPriceHtml = "<span class='money'>" + Shopify.formatMoney(item.price, moneyFormat) + "</span>";

// ✅ fallback de imagem (se vier null)
var imgSrc = item.image ? item.image : "";

var row =
"<tr>" +
"<td class='text-center'>" +
"<a href='" + item.url + "' title='" + item.title + "'>" +
"<img class='cart-image' src='" + imgSrc + "' alt='" + item.title + "' title='" + item.title + "'>" +
"</a>" +
"</td>" +
"<td class='text-left info-item'>" +
"<a class='cart-name' href='" + item.url + "'>" + item.title + "</a>" +
"<p class='cart-quantity'>" + item.quantity + " &times;</p>" +
"<p class='cart-price'>" + unitPriceHtml + "</p>" +
"</td>" +
"<td class='text-center cart-close'>" +
"<button type='button' " + cartRemove + " title='Remover' class='btn btn-danger btn-xs'>" +
"<span aria-hidden='true' style='font-size:24px;line-height:1'>×</span>" +
"</button>" +
"</td>" +
"</tr>";

$('#cart .dropdown-menu > li:first-child .table > tbody').append(row);
});

if (cartData.item_count < 1) {
// ✅ vazio dentro da tabela (HTML válido)
$('#cart .dropdown-menu > li:first-child .table > tbody')
.append(
"<tr class='afb-cart-empty-row'>" +
"<td colspan='3' class='text-center cart-empty'>Seu carrinho está vazio!</td>" +
"</tr>"
);

$('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('show').addClass('hide');
} else {
$('#cart .dropdown-menu .afb-cart-empty-row').remove();
$('#cart .dropdown-menu li:not(:first-child):last-child').removeClass('hide').addClass('show');
}

$('#cart > button #cart-total').html(cartData.item_count);

$('#cart > button .total-price').html(
"<span class='money'>" + Shopify.formatMoney(cartData.total_price, moneyFormat) + "<i class='fas fa-chevron-down'></i></span>"
);

$('#cart-subtotal').html(
"<span class='money'>" + Shopify.formatMoney(cartData.total_price, moneyFormat) + "</span>"
);


if (Currency.cookie.read() != null) {
Currency.convertAll(shopCurrency, Currency.cookie.read());
}

}


/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
e.preventDefault();
$('#modal-agree').remove();

var element = this;

$.ajax({
url: $(element).attr('href'),
type: 'get',
dataType: 'html',
success: function(data) {
var html  = '<div id="modal-agree" class="modal">';
html += '  <div class="modal-dialog">';
html += '    <div class="modal-content">';
html += '      <div class="modal-header">';
html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
html += '      </div>';
html += '      <div class="modal-body">' + data + '</div>';
html += '    </div>';
html += '  </div>';
html += '</div>';

$('body').append(html);
$('#modal-agree').modal('show');
}
});
});


// Autocomplete */
(function($) {
$.fn.autocomplete = function(option) {
return this.each(function() {
this.timer = null;
this.items = new Array();

$.extend(this, option);
$(this).attr('autocomplete', 'off');

// Focus
$(this).on('focus', function() {
this.request();
});

// Blur
$(this).on('blur', function() {
setTimeout(function(object) {
object.hide();
}, 200, this);
});

// Keydown
$(this).on('keydown', function(event) {
switch(event.keyCode) {
case 27: this.hide(); break; // escape
default: this.request(); break;
}
});

// Click
this.click = function(event) {
event.preventDefault();
var value = $(event.target).parent().attr('data-value');
if (value && this.items[value]) {
this.select(this.items[value]);
}
};

// Show
this.show = function() {
var pos = $(this).position();
$(this).siblings('ul.dropdown-menu').css({
top: pos.top + $(this).outerHeight(),
left: pos.left
});
$(this).siblings('ul.dropdown-menu').show();
};

// Hide
this.hide = function() {
$(this).siblings('ul.dropdown-menu').hide();
};

// Request
this.request = function() {
clearTimeout(this.timer);
this.timer = setTimeout(function(object) {
object.source($(object).val(), $.proxy(object.response, object));
}, 200, this);
};

// Response
this.response = function(json) {
var html = '';

if (json.length) {
for (var i = 0; i < json.length; i++) {
this.items[json[i]['value']] = json[i];
}

for (var i2 = 0; i2 < json.length; i2++) {
if (!json[i2]['category']) {
html += '<li data-value="' + json[i2]['value'] + '"><a href="#">' + json[i2]['label'] + '</a></li>';
}
}

// Get all the ones with a categories
var category = new Array();
for (var i3 = 0; i3 < json.length; i3++) {
if (json[i3]['category']) {
if (!category[json[i3]['category']]) {
category[json[i3]['category']] = new Array();
category[json[i3]['category']]['name'] = json[i3]['category'];
category[json[i3]['category']]['item'] = new Array();
}
category[json[i3]['category']]['item'].push(json[i3]);
}
}

for (var k in category) {
html += '<li class="dropdown-header">' + category[k]['name'] + '</li>';
for (var j = 0; j < category[k]['item'].length; j++) {
html += '<li data-value="' + category[k]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[k]['item'][j]['label'] + '</a></li>';
}
}
}

if (html) { this.show(); } else { this.hide(); }
$(this).siblings('ul.dropdown-menu').html(html);
};

$(this).after('<ul class="dropdown-menu"></ul>');
$(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));
});
}
})(window.jQuery);
